<div class="d-flex">
  <aside
    class="side-nav"
    [ngClass]="{ 'side-nav-expanded': !isSideNavCollapsed }"
    data-automation="auto-attendants-sidebar"
  >
    <div
      class="d-flex align-items-center"
      [ngClass]="{ 'side-nav-expanded__toggle': !isSideNavCollapsed, 'side-nav__toggle': isSideNavCollapsed }"
    >
      @if (!isSideNavCollapsed) {
        <h5 class="strong">{{ 'tkey;migrations.ring_central.auto_attendants_report.sidebar.title' | translate }}</h5>
      }
      <button
        data-automation="auto-attendants-sidebar-toggle-btn"
        #sidebarTooltip="ngbTooltip"
        (click)="toggleSidebar(); sidebarTooltip.close()"
        class="side-nav__toggle-btn"
        [disableTooltip]="!isSideNavCollapsed"
        [ngbTooltip]="'tkey;migrations.ring_central.auto_attendants_report.sidebar.toggle' | translate"
        [container]="'body'"
        [placement]="'right'"
      >
        <i [class]="isSideNavCollapsed ? ziroIcons.NEXT : ziroIcons.PREVIOUS"></i>
      </button>
    </div>

    @if (!isSideNavCollapsed) {
      <div class="side-nav-expanded__items-container" data-automation="auto-attendants-sidebar-items">
        @for (entry of allAutoAttendants; track entry.id) {
          <div
            (click)="navigateToAutoAttendant(entry.id)"
            [attr.data-automation]="'sidebar-' + entry.id"
            class="side-nav-expanded__item mb-1"
            [ngClass]="{ 'side-nav-expanded__item--active': entry.id === autoAttendant?.id }"
          >
            <span class="strong">{{ entry.name }}</span>
            <span class="side-nav-expanded__item-sub text-muted">
              @if (entry.extension) {
                {{
                  'tkey;migrations.ring_central.auto_attendants_report.sidebar.item.extension'
                    | translate: { extension: entry.extension }
                }}
              } @else {
                <i>
                  {{
                    'tkey;migrations.ring_central.auto_attendants_report.sidebar.item.extension.not_configured'
                      | translate
                  }}
                </i>
              }
            </span>
          </div>
        }
      </div>
    }
  </aside>

  <main class="content container" [ngClass]="{ 'content-expanded': !isSideNavCollapsed }">
    @if (isLoading) {
      <ziro-loading-block></ziro-loading-block>
    } @else {
      <ziro-breadcrumbs>
        <ziro-breadcrumb-card-item [aboutCardId]="150"></ziro-breadcrumb-card-item>
      </ziro-breadcrumbs>

      <div class="row mb-3">
        <div class="col-lg-6">
          <ziro-collapsible-section-card
            [isSwitchHidden]="true"
            [isCollapsible]="false"
            [title]="autoAttendant.name"
            [subtext]="'tkey;migrations.ring_central.auto_attendants_report.explorer.general_settings.description'"
            [icon]="ziroIcons.AUTO_ATTENDANT"
            class="d-block h-100"
            data-automation="auto-attendants-general-settings-card"
          >
            <div class="px-3 py-2 d-flex justify-content-between align-items-center">
              <strong>
                {{
                  'tkey;migrations.ring_central.auto_attendants_report.explorer.general_settings.phone_numbers'
                    | translate
                }}
              </strong>
              <span data-automation="general-settings-phone-numbers">
                {{
                  directNumbers ||
                    ('tkey;migrations.ring_central.auto_attendants_report.explorer.general_settings.not_configured'
                      | translate)
                }}
              </span>
            </div>
            <div class="px-3 py-2 d-flex justify-content-between align-items-center">
              <strong>
                {{
                  'tkey;migrations.ring_central.auto_attendants_report.explorer.general_settings.language' | translate
                }}
              </strong>
              <span data-automation="general-settings-language">{{ autoAttendant.language }}</span>
            </div>
            <div class="px-3 py-2 d-flex justify-content-between align-items-center">
              <strong>
                {{ 'tkey;migrations.ring_central.auto_attendants_report.explorer.general_settings.site' | translate }}
              </strong>
              <span data-automation="general-settings-site">{{ autoAttendant.site }}</span>
            </div>
          </ziro-collapsible-section-card>
        </div>

        <div class="col-lg-6">
          <ziro-collapsible-section-card
            [isSwitchHidden]="true"
            [isCollapsible]="false"
            [title]="'tkey;migrations.ring_central.auto_attendants_report.explorer.greeting.title'"
            [subtext]="'tkey;migrations.ring_central.auto_attendants_report.explorer.greeting.description'"
            [icon]="ziroIcons.ANNOUNCEMENTS"
            class="d-block h-100"
            data-automation="auto-attendants-greeting-card"
          >
            <div class="px-3 py-2">
              @if (autoAttendant.greeting?.ttsMessage) {
                <div class="d-flex flex-column">
                  <label class="fw-semibold mb-2">
                    {{
                      'tkey;migrations.ring_central.auto_attendants_report.explorer.greeting.tts_message' | translate
                    }}
                  </label>
                  <span data-automation="greeting-tts-message">{{ autoAttendant.greeting.ttsMessage }}</span>
                </div>
              } @else if (autoAttendant.greeting?.audioFile) {
                <div class="d-flex flex-column">
                  <label class="fw-semibold mb-2">
                    {{ 'tkey;migrations.ring_central.auto_attendants_report.explorer.greeting.audio_file' | translate }}
                  </label>
                  <div class="d-flex align-items-center gap-2">
                    <audio
                      class="flex-grow-1"
                      controls
                      [src]="greetingAudioUrl"
                      [title]="autoAttendant.greeting.audioFile.filename"
                      data-automation="greeting-audio-player"
                    ></audio>
                    <a
                      [href]="greetingAudioUrl"
                      [download]="autoAttendant.greeting.audioFile.filename"
                      class="btn btn-border btn-link p-0"
                    >
                      <i [class]="ziroIcons.DOWNLOAD_SMALL + ' font-size-18'"></i>
                    </a>
                  </div>
                </div>
              } @else {
                <span class="text-muted">
                  {{ 'tkey;migrations.ring_central.auto_attendants_report.explorer.greeting.none.label' | translate }}
                </span>
              }
            </div>
          </ziro-collapsible-section-card>
        </div>
      </div>

      <ziro-collapsible-section-card
        [isSwitchHidden]="true"
        [isCollapsible]="false"
        [title]="'tkey;migrations.ring_central.auto_attendants_report.explorer.menu_buttons.title'"
        [subtext]="'tkey;migrations.ring_central.auto_attendants_report.explorer.menu_buttons.description'"
        [icon]="ziroIcons.PHONE_DIAL"
        data-automation="auto-attendants-menu-buttons-card"
      >
        <div class="call-flow-buttons" data-automation="ring-central-auto-attendants-menu-buttons-list">
          @for (btn of configuredButtons; track btn.keyLabel) {
            <div class="call-flow-buttons__row" data-automation="menu-button-configured-row">
              <div class="call-flow-buttons__key">{{ btn.keyLabel }}</div>
              <div class="call-flow-buttons__name">{{ btn.action }}</div>
            </div>
          }

          @if (unconfiguredButtons.length > 0) {
            <div
              class="call-flow-buttons__unused-header"
              (click)="toggleUnconfiguredButtons()"
              data-automation="toggle-unconfigured-buttons"
            >
              <span class="d-flex align-items-center gap-2">
                {{
                  (showUnconfiguredButtons
                    ? 'tkey;migrations.ring_central.auto_attendants_report.explorer.menu_buttons.hide_unconfigured'
                    : 'tkey;migrations.ring_central.auto_attendants_report.explorer.menu_buttons.show_unconfigured'
                  ) | translate
                }}
                <span class="call-flow-buttons__unused-count badge rounded-pill">{{ unconfiguredButtons.length }}</span>
              </span>
              <i [class]="showUnconfiguredButtons ? ziroIcons.MENU_EXPANDED : ziroIcons.MENU_MINIMIZED"></i>
            </div>

            @if (showUnconfiguredButtons) {
              @for (btn of unconfiguredButtons; track btn.keyLabel) {
                <div
                  class="call-flow-buttons__row call-flow-buttons__row--unused"
                  data-automation="menu-button-unconfigured-row"
                >
                  <div class="call-flow-buttons__key call-flow-buttons__key--unused">{{ btn.keyLabel }}</div>
                  <div class="call-flow-buttons__name call-flow-buttons__name--unused">
                    {{
                      'tkey;migrations.ring_central.auto_attendants_report.explorer.menu_buttons.not_configured'
                        | translate
                    }}
                  </div>
                </div>
              }
            }
          }

          @if (noInputButton) {
            <div class="call-flow-buttons__row call-flow-buttons__row--last" data-automation="menu-button-no-input-row">
              <div
                class="call-flow-buttons__key call-flow-buttons__key--no-input"
                [ngbTooltip]="
                  'tkey;migrations.ring_central.auto_attendants_report.explorer.menu_buttons.no_inputs.tooltip'
                    | translate
                "
              >
                {{ noInputButton.keyLabel }}
              </div>
              <div class="call-flow-buttons__name">{{ noInputButton.action }}</div>
            </div>
          }
        </div>
      </ziro-collapsible-section-card>
    }
  </main>
</div>
